import { Button, Row } from 'antd';
import * as React from 'react';

export default class LotSearchReloadButton extends React.Component<any, any> {

  constructor(props: any) {
    super(props);
  }

  reloadPage = () => {
    window.location.reload();
  };

  render() {
    return (
      <Row style={{paddingTop: '10px'}} >
        <Button type='primary' icon='reload' onClick={this.reloadPage}>Lot Search Applied, Click to clear</Button>
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/LotSearchReloadButton.tsx